// import { useSelector } from "react-redux";
import { Grid, Typography } from "@mui/material";
// import { getThemeCompareSelectedValue } from "../../../reducer/patientCompareSlice";


const label = ["1 - 28", '29 - 56', '> 56']
const size = [10, 22, 34];

function ClusterLegend(props) {
    // const themeCompare = useSelector(getThemeCompareSelectedValue);
    // const populationValue = useSelector(getPopulationRate);

    return (
        <>
            <div style={{
                position: 'relative'
            }}>
                <Typography sx={{ 
                    fontSize: 12, 
                    textAlign: 'left',
                    fontWeight: '400',
                }}>
                    ระยะเวลาของกลุ่มผู้ป่วย (วัน)
                </Typography>
                <Grid container spacing={0}>
                {
                    size.map((data, index) => {
                        // console.log(data);
                        return (
                            <Grid 
                                key={index} 
                                item 
                                xs={(12/size.length)}
                                sx={{
                                    alignItems: 'center',
                                    display: 'flex',
                                    justifyContent: 'center'
                                }}
                            >
                                <div style={{
                                    height: `${data}px`,
                                    width: `${data}px`,
                                    borderRadius: '50px',
                                    borderStyle: 'solid',
                                    borderWidth: '3px',
                                    borderColor: '#009dff'
                                }}></div>
                            </Grid>
                        )
                    })
                }
                {
                    label.map((data, index) => {
                        return (
                            <Grid key={index} item xs={(12/label.length)}>
                                <Typography sx={{
                                    fontSize: 10,
                                    textAlign: 'center',
                                    marginTop: '5px',
                                    fontWeight: '400',
                                }}>
                                    {data}
                                </Typography>
                            </Grid>
                        )
                    })
                }
                </Grid>
            </div>
        </>
    )
}

export default ClusterLegend;